import { useT } from '@/context/LocaleContext';
import { Globe } from 'lucide-react';

export default function LanguageSelector({ compact = false }) {
  const { locale, setLocale, supported, t } = useT();

  return (
    <div className={`flex items-center gap-2 ${compact ? '' : 'text-sm'}`} data-testid="lang-selector">
      {!compact && <Globe size={14} className="text-stone-500" />}
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        aria-label={t('common.language')}
        className="bg-stone-900 border border-stone-800 rounded-full px-3 py-1.5 text-sm text-stone-100 focus:outline-none focus:border-orange-800"
        data-testid="lang-select"
      >
        {supported.map(l => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>
    </div>
  );
}
